module.exports = __webpack_public_path__ + "img/image5.4902968a.png";